  <template>
    <div class="h100vh-116">
      <div class='h-ainfoBg'>
        <div class='h-ainfo'>
          <span class='icon hero-icon hero-icon-detailcode'></span>
          <span>{{$t('MCS.choosed')}} {{ chooseCount }} {{$t('MCS.num')}}</span>
        </div>
      </div>
      <div style="height: calc(100vh - 200px) !important;">
        <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='actionComplete' :allowReordering='true' :allowResizing='false'>
          <e-columns>
            <e-column type='checkbox' clipMode='EllipsisWithTooltip' headerText='userNum' textAlign='Center' width='30'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userNum")' width='150' textAlign='Center'></e-column>
            <e-column field='userAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
            <e-column field='userType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
            <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='registerStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>
<!--            <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='videoRegisterStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>-->
<!--            <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='dataRegisterStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>-->
            <e-column field='stunStatus' clipMode='EllipsisWithTooltip' :valueAccessor='stunStatusFormatter' :headerText='$t("MCS.stunKillStatus")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <CustomDialog ref='addUserPage' :element='dialog.element.eleAddUser' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddUserDialog ref='addUser' opCode='0' :neid='neid' :vpnId='vpnId' :gmsNeid='gmsNeid' :equipmentIPId='equipmentIPId'></AddUserDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='modUserPage' :element='dialog.element.eleModUser' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddUserDialog ref='modUser' opCode='1' :neid='neid' :vpnId='vpnId' :gmsNeid='gmsNeid' :equipmentIPId='equipmentIPId'></AddUserDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='groupListPage' :element='dialog.element.eleQryGroup' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <GroupList ref='groupList' :neid='neid' :vpnId='vpnId'></GroupList>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBlackListPage' :element='dialog.element.eleAddBlack' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddBlackDialog ref='addBlackList' :neid='neid' :vpnId='vpnId' :vpnClass='vpnClass'></AddBlackDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='qryBlackListPage' :element='dialog.element.eleModBlack' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <QryBlackDialog ref='qryBlackList' :neid='neid' :vpnId='vpnId'></QryBlackDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='addAreaListPage' :element='dialog.element.eleAddArea' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <AddAreaDialog ref='addAreaList' :neid='neid' :vpnId='vpnId'></AddAreaDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='qryAreaListPage' :element='dialog.element.eleQryArea' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <QryAreaDialog ref='qryAreaList' :neid='neid' :vpnId='vpnId'></QryAreaDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='superSearchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch'>
        <template v-slot:dialog-content>
          <SuperSearch ref='superSearch' :userNumValue='userNumSearch' :userTypeValue='userTypeSearch' :reFreshGrid='reFreshGrid'></SuperSearch>
        </template>
      </CustomDialog>
      <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
        <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
        </template>
      </CustomDialog>
    </div>
  </template>
<script>
import { Edit, Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import AddUserDialog from './dialog/AddUserDialog';
import CustomDialog from '../../../common/CustomDialog';
import GroupList from './dialog/QryGroupDialog';
import AddBlackDialog from './dialog/AddBlackDialog';
import QryBlackDialog from './dialog/QryBlackDialog';
import AddAreaDialog from './dialog/AddAreaDialog';
import QryAreaDialog from './dialog/QryAreaDialog';
import SuperSearch from './dialog/SearchDialog';
import DialogList from '../../../subscriberconfig/util/tipDialog/DialogList';
import commonJS from '../common';
import { EventBus } from "../../../../plugins/eventBus";

export default {
  name: 'CMSUsers',
  props:[
    'qryNeids'
  ],
  components: {
    CustomDialog,
    AddUserDialog,
    GroupList,
    AddBlackDialog,
    QryBlackDialog,
    AddAreaDialog,
    QryAreaDialog,
    SuperSearch,
    DialogList
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      dataExport: {},
      requestAllData: [],
      dataExportPage: {
        pageNo: '',
        pageSize: 100
      },
      equipmentIPId: '',
      userNumSearch: '',
      userTypeSearch: 0,
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      neid: '',
      vpnId: '',
      vpnClass: '',
      node: '',
      gmsNeid: '',
      vo: {
        vpnid: '',
        flag: '',
        participantType: ''
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          model: true,
          visible: false
        },
        stylesSearch: {
          width: '400px',
          height: '300px',
          visible: false,
          model: true
        },
        element: {
          eleAddUser: {
            target: this.$refs.userstable,
            refName: 'eleAddUser',
            buttonGroup: [
              { click: this.closeAddUserPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveAddUser, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.addUser'),
            isClose: true
          },
          eleModUser: {
            target: this.$refs.userstable,
            refName: 'eleModUser',
            buttonGroup: [
              { click: this.closeModUserPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveModUser, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.modUser'),
            isClose: true
          },
          eleQryGroup: {
            target: this.$refs.userstable,
            refName: 'eleQryGroup',
            buttonGroup: [
              { click: this.closeQryGroupList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.qryGroupList'),
            isClose: true
          },
          eleAddBlack: {
            target: this.$refs.userstable,
            refName: 'eleAddBlack',
            buttonGroup: [
              { click: this.closeAddBlackList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addBlackNum'),
            isClose: true
          },
          eleModBlack: {
            target: this.$refs.userstable,
            refName: 'eleModBlack',
            buttonGroup: [
              { click: this.closeQryBlackList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.manageBlackNum'),
            isClose: true
          },
          eleAddArea: {
            target: this.$refs.userstable,
            refName: 'eleAddArea',
            buttonGroup: [
              { click: this.closeAddAreaList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addAreaNum'),
            isClose: true
          },
          eleQryArea: {
            target: this.$refs.userstable,
            refName: 'eleQryArea',
            buttonGroup: [
              { click: this.closeQryAreaList, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.manageAreaNum'),
            isClose: true
          },
          eleSearch: {
            target: this.$refs.userstable,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closeSearch, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveSearch, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.qry'),
            isClose: true
          },
        },
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.cancle') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    getGridData(node = null, firstPageFlag = false) {
      const $this = this;
      let pageNo = $this.$refs.pager.ej2Instances.currentPage;
      $this.node = node;
      if (node !== null) {
        const array = node.id.split('_');
        const gmsNeid = array[0];
        const vpnId = array[2];
        const vpnClass = parseInt(node.level, 0) - 1;
        $this.gmsNeid = gmsNeid;
        $this.vpnId = vpnId;
        $this.vpnClass = vpnClass;
        $this.equipmentIPId = node.neNode.equipmentIPId;
        $this.page.pageNo = 1;
        pageNo = 1;
        this.clearCondition();
      }
      if (firstPageFlag === true) {
        $this.page.pageNo = 1;
        pageNo = 1;
        $this.$refs.pager.ej2Instances.goToPage(1);// 高级搜索时默认显示第一页的结果
      }
      this.$axios.post('/lte/ems/auth/findElementListByAuth', [2110]).then((response) => {
        response.data.forEach((item) => {
          if (item.equipmentIPId === this.equipmentIPId) {
            $this.neid = item.id;
            return false;
          }
          return true;
        });
        const vo = {
          flag: 2,
          userNum: this.userNumSearch,
          userType: this.userTypeSearch,
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          vpnId: $this.vpnId,
          vpnClass: $this.vpnClass
        };
        const params = {
          info: this.setInfo(this.msg.qryUsers),
          vo: vo,
          page: {
            pageNo: pageNo,
            pageSize: this.page.pageSize
          }
        };
        EventBus.$emit('loading', { ison: true });
        this.$axios.post(this.requestCommon, params).then((response) => {
          const res = response.data;
          const resData = res.resultVal.result;
          EventBus.$emit('loading', { ison: false });
          $this.data = resData;
          $this.page.totalCount = res.resultVal.totalCnt;
          $this.$refs.grid.clearSelection();
        });
      });
    },

    isChooseNe() {
      if (this.neid === '') {
        this.$toast('warning', this.$t('MCS.chooseNe'));
        return false;
      }
      return true;
    },

    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.$toast('warning', this.$t('MCS.onlyData'));
        return false;
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      const userNum = [];
      if (this.isChooseNe() !== false) {
        // x-> false: 不支持多选   true: 支持多选
        const checkedData = this.getCheckedData(selectOnly);
        for (let i = 0; i < checkedData.length; i++) {
          userNum.push(checkedData[i].userNum);
        }
      }
      return userNum;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },

    actionComplete(){
      this.$refs.grid.selectRow(0,true);
      this.$refs.grid.selectRow(0,true);
    },

    /**
     * 打开/关闭/保存  添加用户页面
     */
    openAddUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      // if (parseInt(this.vpnId) === 0) {
      //   this.$toast('failure', this.$t('MCS.vpn0CantAddUser'));
      //   return;
      // }
      this.$refs.addUser.mainHandler();
      this.$refs.addUserPage.show();
    },
    closeAddUserPage() {
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },
    saveAddUser() {
      const $this = this;
      const datas = this.$refs.addUser.getDatas();
      datas.vpnId = $this.vpnId;
      const userNumList = [];
      const userNum = this.$refs.addUser.getDatas().userNum;
      const opCount = this.$refs.addUser.getDatas().opCount;
      const userType = parseInt(this.$refs.addUser.getDatas().userType);
      const resObj = [];
      for (let i = 0; i < opCount; i++) {
        const resData = {};
        resData.operObj = parseInt(userNum) + i;
        userNumList.push(resData.operObj);
        resObj.push(resData);
      }
      if (datas === false)  return;
      if (parseInt(datas.vpnId) === 0 && (userType === 1 || userType === 7)) {
        $this.$toast('warning', $this.$t('MCS.vpn0CantAddUsOrMo'));
        return;
      }
      const params = {
        vo: datas,
        info: this.setInfo(this.msg.addUser),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.addUser',
          exectype: 1,
          execData: userNumList
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        this.getGridData();
      });
      // this.$layer.success();
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },

    /**
     * 打开/关闭/保存  修改用户页面
     */
    openModUserPage() {
      const $this = this;
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        const vo = {
          userNum: this.getCheckedData()[0].userNum,
          flag: 1,
          userType: 0,
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          vpnId: 0,
          vpnClass: 0,
        };
        const page = {
          pageNo: 1,
          pageSize: 15
        };
        const params = {
          info: this.setInfo(this.msg.qryModUser),
          vo: vo,
          page: page
        };
        this.$axios.post(this.requestCommon, params).then((response) => {
          const data = response.data.resultVal.result[0];
          this.$refs.modUser.mainHandler(data);
          this.$refs.modUserPage.show();
        });
      }
    },
    closeModUserPage() {
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },
    saveModUser() {
      const $this = this;
      const datas = $this.$refs.modUser.getDatas();
      if (datas === false) return;
      const params = {
        vo: datas,
        info: $this.setInfo($this.msg.modUser),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.modUser',
          exectype: 1,
          execData: [datas.userNum]
        }
      };
      this.$axios.post($this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        $this.getGridData();
      });
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },

    /**
     * 删除用户
     */
    delUsers() {
      const userNum = this.getCheckedVals(true);
      const $this = this;
      if (userNum.length > 0) {
        this.$layer.confirm({
          msg: this.$t('MCS.deleteConfirm'),
          btn1: {
            msg: this.$t('MCS.cancle'),
          },
          btn2: {
            msg: this.$t('MCS.confirm'),
            func: () => {
              const resObj = [];
              const vo = {
                enterpriseDomain: $this.enterpriseDomain,
                productType: $this.productType,
                opCount: userNum.length,
                userNum: userNum
              };
              for (let i = 0; i < vo.opCount; i++) {
                const resData = {};
                resData.operObj = userNum[i];
                resObj.push(resData);
              };
              const params = {
                vo: vo,
                info: this.setInfo(this.msg.delUser),
                log: {
                  module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
                  execFunName: 'subscriber.delUser',
                  exectype: 1,
                  execData: userNum
                }
              };
              this.$axios.post(this.requestCommon, params).then((response) => {
                $this.commonResp(response);
                this.getGridData(null, true);
              });
            }
          }
        });
      }
    },

    /**
     * 打开/关闭/保存  组呼列表页面
     */
    openQryGroupListPage() {
      const $this = this;
      const userNum = $this.getCheckedVals();
      if (userNum.length !== 0) {
        const vo = {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          flag: 1,
          page: 0,
          count: 200,
          userNum: userNum[0]
        };
        const page = {
          pageNo: 1,
          pageSize: 100
        };
        this.$refs.groupList.getGroupList(page, vo, $this.getCheckedData()[0].userNum);
        this.$refs.groupListPage.show();
      }
    },
    closeQryGroupList() {
      this.$refs.groupListPage.clear();
      this.$refs.groupListPage.close();
    },

    /**
     * 打开/关闭/保存  添加黑名单页面
     */
    openAddBlackListPage() {
      const userNum = this.getCheckedVals();
      if (userNum.length !== 0) {
        this.$refs.addBlackList.getGridData(userNum[0]);
        this.$refs.addBlackListPage.show();
      }
    },
    closeAddBlackList() {
      this.$refs.addBlackListPage.clear();
      this.$refs.addBlackListPage.close();
    },

    /**
     * 打开/关闭/保存  黑名单管理页面
     */
    openQryBlackListPage() {
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        this.$refs.qryBlackList.getGridData(mcsid, this.getCheckedData()[0].userNum);
        this.$refs.qryBlackListPage.show();
      }
    },
    closeQryBlackList() {
      this.$refs.qryBlackListPage.clear();
      this.$refs.qryBlackListPage.close();
    },

    /**
     * 鎵撳紑/鍏抽棴/淇濆瓨  娣诲姞灏忓尯椤甸潰
     */
    openAddAreaListPage() {
      debugger;
      const mcsid = this.getCheckedVals();
      if (mcsid.length !== 0) {
        if(this.getCheckedData()[0].userType === '3' || this.getCheckedData()[0].userType === '5'){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('MCS.cannotaddtocell') });
          return;
        }
        this.$refs.addAreaList.getGridData(mcsid[0], this.getCheckedData()[0].userNum);
        this.$refs.addAreaListPage.show();
      }
    },
    closeAddAreaList() {
      this.$refs.addAreaListPage.clear();
      this.$refs.addAreaListPage.close();
    },

    /**
     * 鎵撳紑/鍏抽棴/淇濆瓨  灏忓尯绠＄悊椤甸潰
     */
    openQryAreaListPage() {
      const mcsid = this.getCheckedVals(false);
      if (mcsid.length !== 0) {
        this.$refs.qryAreaList.getGridData(mcsid, this.getCheckedData()[0].userNum);
        this.$refs.qryAreaListPage.show();
      }
    },
    closeQryAreaList() {
      this.$refs.qryAreaListPage.clear();
      this.$refs.qryAreaListPage.close();
    },

    /**
     * 导出
     */
    async exportData() {
      const userNumList = [];
      const checkedDatas = this.getCheckedData(true);

      if(!checkedDatas){
        return;
      }
      for(let i = 0; i < checkedDatas.length; i++){
        userNumList.push(checkedDatas[i].userNum);
      }


      let _nodeArray;
      let searchVpnId;
      await this.$axios.post('/lte/ems/auth/findElementListByAuth', [2110,2142]).then((response) => {
        if (response.status !== 200) {
          // $this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          $this.$loading.hideLoadding();
        }else {
          _nodeArray = response.data;
        }
      })

      let equipmentIPId;
      for (let i = 0; i < _nodeArray.length; i++) {
        if(_nodeArray[i].id == this.neid){
          equipmentIPId = _nodeArray[i].equipmentIPId;
        }
      }
      for (let i = 0; i < _nodeArray.length; i++) {
        if(_nodeArray[i].equipmentIPId == equipmentIPId && _nodeArray[i].id != this.neid){
          searchVpnId = _nodeArray[i].id
        }
      }

      const paramsOfUser = {
        info: {
          neid: this.neid,
          operation: 'batchUserExport'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: this.enterpriseDomain,
              flag: 1,
              productType: this.productType,
              userNum: userNumList,
              userType: 0,
              vpnClass: 0,
              vpnId: 0
            },
            info: {
              neid: this.neid,
              msgid: this.msg.qryModUser
            },
            page: {
              pageNo: 1,
              pageSize: 15
            }
          }
        }
      }


      const paramsOfVpn = {
        info: {
          neid: this.qryNeids,
          operation: 'getVpnTreeWithNeid'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: this.enterpriseDomain,
              flag: 0,
              neid: this.qryNeids,
              productType: this.productType,
              vpnId: ""
            },
            info: {
              enterpriseDomain: this.enterpriseDomain,
              msgid: this.msg.qryVpnId,
              neid: this.qryNeids,
              productType: this.productType
            },
            page: {
              page:1,
              count:400
            }
          }
        }
      }

      const params = {
        paramsCommon: paramsOfUser,
        paramOfVpn: paramsOfVpn
      }

      const config = {
        responseType: 'blob'
      };
      this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post(`/lte/ems/subscriber/mcs/batch/batchExport.html?exportType=1&searchVpnId=${searchVpnId}&neid=${this.neid}&msgid=43000`, params, config).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
       const dateStr = new Date().Format('yyyyMMdd_HH-mm');
        const fileName = `${this.$t('SubscriberIms.user')}_${dateStr}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
      });
    },

    /**
     * 打开/关闭/保存  高级搜索
     */
    openSearchPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.superSearchPage.show();
      this.$refs.superSearch.bindValidate();
      return null;
    },
    closeSearch() {
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },
    saveSearch() {
      if (!this.$refs.superSearch.checkValid()) {
        return;
      }
      this.$refs.superSearch.search();
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    setInfo(msgid) {
      return {
        msgid: msgid,
        neid: this.neid,
      };
    },

    clearCondition() {
      this.userTypeSearch = 0;
      this.userNumSearch = '';
      this.$refs.superSearch.setData(0, '');
    },

    reFreshByNoCondition() {
      this.clearCondition();
      this.getGridData();
    },

    reFreshGrid(userType, userNum) {
      this.userTypeSearch = userType;
      this.userNumSearch = userNum;
      this.getGridData(null, true);
    },

    excelExp() {
      const dateStr = new Date().Format(`yyyy-MM-dd HH：mm`);
      const _excelName = `${this.$t('MCS.user')}_${dateStr}.xlsx`;
      this.$refs.gridExport.excelExport( { fileName: _excelName } );
    }

  },
  created() {
  }
};
</script>

<style scoped>

</style>
